export const DCornerMask = wcardinal.ui.DCornerMask;